import { IProjectCostCodeCostTypeItem } from '../../interfaces/iproject-cost-code-cost-type-item';
import { CostCodeCostType } from '../cost-code-cost-type';
import { Project } from '../project';
import { UnitOfMeasure } from '../unit-of-measure';

export class ProjectCostCodeCostTypeItemBase {
  ProjectCostCodeCostTypeItemId: number;
  ProjectId: number;
  CostCodeCostTypeId: number | null;
  EstimateDate: Date | null;
  ExtendedValue: number | null;
  Quantity: number | null;
  EstimateVersion: number | null;
  LastUpdatedDate: Date | null;
  LastUpdatedUser: string | null;
  Rate: number | null;
  UnitOfMeasureId: number | null;
  IsManualAdd: boolean | null;
  Phase: string | null;
  Step: string | null;
  NeedByDate: Date | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  CostCodeCostType?: CostCodeCostType;
  Project?: Project;
  UnitOfMeasure?: UnitOfMeasure;

  constructor(item?: IProjectCostCodeCostTypeItem) {
    if (item) {

      this.ProjectCostCodeCostTypeItemId = item.ProjectCostCodeCostTypeItemId;
      this.ProjectId = item.ProjectId;
      this.CostCodeCostTypeId = item.CostCodeCostTypeId;
      this.EstimateDate = item.EstimateDate ? new Date(item.EstimateDate) : null;
      this.ExtendedValue = item.ExtendedValue;
      this.Quantity = item.Quantity;
      this.EstimateVersion = item.EstimateVersion;
      this.LastUpdatedDate = item.LastUpdatedDate ? new Date(item.LastUpdatedDate) : null;
      this.LastUpdatedUser = item.LastUpdatedUser;
      this.Rate = item.Rate;
      this.UnitOfMeasureId = item.UnitOfMeasureId;
      this.IsManualAdd = item.IsManualAdd;
      this.Phase = item.Phase;
      this.Step = item.Step;
      this.NeedByDate = item.NeedByDate ? new Date(item.NeedByDate) : null;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.CostCodeCostType = new CostCodeCostType(item.CostCodeCostType);
      this.Project = new Project(item.Project);
      this.UnitOfMeasure = new UnitOfMeasure(item.UnitOfMeasure);
    }
  }
}